import { createModel } from "nyax";
import { Package, PackageQuery } from "src/models/package";
import { PackageEntityModel } from "src/store/models/entity/package/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const PackageSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<Package, PackageQuery>({
    setItems: (getContainer, items) =>
      getContainer(PackageEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(PackageEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(PackageEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: PackageQuery
            ) =>
              this.dependencies.serviceClient.package.list(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
